<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <el-row type="flex" v-show="hasData && !isDetail">
          <tg-button
            round
            border
            hoverBorderOnly
            theme="primary"
            @click.native="handleUserFilter(false)"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-filter"
                :class="{ active: scope.isHover || scope.isFocus }"
              ></i>
            </template>
            {{ $t("component.btn.filter") }}
          </tg-button>
          <tg-button
            v-if="isFiltered"
            :disabled="!canRefresh"
            round
            border
            hoverBorderOnly
            theme="primary"
            @click.native="handleRefreshFiltered"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-reload"
                :class="{ active: scope.isHover || scope.isFocus }"
              ></i>
            </template>
            {{ $t("component.btn.refresh") }}
            <template v-if="!canRefresh">
              (
              <span>{{ nextRefresh }}</span
              >)
            </template>
          </tg-button>
          <tg-button
            icon="reply"
            round
            border
            hoverBorderOnly
            theme="primary"
            @click.native="handleUserFilter(true)"
            :disabled="!isFiltered"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-recovery"
                :class="{ active: scope.isHover || scope.isFocus }"
              ></i>
            </template>
            {{ $t("component.btn.recover") }}
          </tg-button>
        </el-row>

        <tg-search-tool @on-submit="handleSearch">
          <tg-date-search
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            showDateRangePicker
            showTomorrow
            oneYearLimit
          ></tg-date-search>
          <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="targetName"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
          <el-switch
            v-model="showPeople"
            :active-color="this.$theme == 'dark-purple' ? '#5e77ff' : '#065498'"
            inactive-color="#909399"
            :active-text="$t('enum.showPeople[' + (showPeople ? 1 : 0) + ']')"
            inactive-icon-class="abc"
            validate-event="false"
            class="ma-r-3"
          ></el-switch>
          <template slot="right"></template>
        </tg-search-tool>
        <el-row type="flex" v-show="hasData">
          <tg-button
            round
            border
            hoverBorderOnly
            theme="info"
            @click.native="handleExport"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.export") }}
          </tg-button>
          <tg-button
            v-if="showExportMember"
            v-show="hasData"
            theme="primary"
            round
            border
            hoverBorderOnly
            @click.native="handleExportMember"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export-p"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.exportMember") }}
          </tg-button>
          <tg-button
            v-if="hasData && $user.group >= 70"
            theme="primary"
            round
            border
            hoverBorderOnly
            @click.native="handleExportAllLevels"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.exportAllLevels") }}
          </tg-button>
        </el-row>
      </el-row>

      <el-row style="padding: 5px">
        <!-- 平台選擇按鈕 -->
        <third-party-search-btn
          :style="{ display: !showThirdParty ? 'none' : 'initial' }"
          @click.native="showThirdPartyCheckBoxDialog"
        ></third-party-search-btn>
        <third-party-platform
          :style="{ display: !showThirdParty ? 'none' : 'initial' }"
          v-model="thirdPartyData"
          @on-change="handleSearchThirdParty"
        ></third-party-platform>
      </el-row>
      <el-row style="padding: 5px">
        <!-- 玩法選擇按鈕 -->
        <third-party-search-btn
          :style="{ display: !showMarketTypeFilter ? 'none' : 'initial' }"
          :text="$t('component.btn.marketType_choose')"
          @click.native="showMarketTypeFilterDialog"
        ></third-party-search-btn>
        <third-party-platform
          :style="{ display: !showMarketTypeFilter ? 'none' : 'initial' }"
          v-model="marketTypeItems"
          @on-change="handleMarketTypeItemsChange"
        ></third-party-platform>
      </el-row>
      <el-row v-if="showComposed">
        <template v-for="(row, i) in composed">
          <tg-button
            :key="'composed-' + i"
            round
            border
            hoverBorderOnly
            theme="primary"
            :active-gradient="row.value == groupLine"
            @click.native="toggleGroupLine(row)"
          >
            {{ row.item }}
          </tg-button>
        </template>
      </el-row>
      <!-- <span class="fs-sm">{{ $t("note.twoMonthOnly") }}</span> -->
      <tg-amount-bar
        ref="amount"
        v-if="showAmount"
        :columns="amountColumns"
        :row="amountData"
        :mouseTouch="false"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      :filterMethods="filterMethods"
      :sortMethods="sortMethods"
      @on-loaded="handleLoaded"
      @filter-change="handleFilterChange"
      :summary-method="parsePageSummary"
      showSummary
      :showPagination="isDetail"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name-with-link
          class="clickable text-primary"
          :row="scope.row"
          :column="scope.column"
          :token="scope.row['betId'] ? null : generalQueryToken(scope.row)"
          route="accounts.history.user"
        ></tg-user-full-name-with-link>
      </template>
      <template slot="bet" slot-scope="scope">
        <router-link
          :to="{
            name: 'accounts.paper.bet',
            params: { targetName: scope.row['name'] },
          }"
          >{{ scope.formated }}</router-link
        >
      </template>
      <template slot="event_bonus" slot-scope="scope">
        {{ scope.row.event_bouns ? scope.row.event_bouns : "0.00" }}
      </template>

      <template slot="deviceInfo" slot-scope="scope">
        <span>{{ scope.row.ip }}</span
        ><br />
        <span style="color: gray; font-size: 12px">{{
          scope.row.platform
        }}</span>
      </template>

      <!-- 賽事內容 -->
      <template slot="betContent" slot-scope="scope">
        <tg-bet-content
          v-if="scope.row.source_type == 'tg'"
          :row="scope.row"
        ></tg-bet-content>
        <third-party-saba-bet-content
          v-else-if="
            ((scope.row.source_type == 'saba' ||
              scope.row.source_type == 'sabawhite_sport') &&
              (scope.row.content_type == 2 || scope.row.content_type == 5)) ||
            (scope.row.source_type.includes('sport') &&
              scope.row.serial_type == 1) //serial_type == 1 非串關
          "
          :row="scope.row"
        ></third-party-saba-bet-content>
        <third-party-saba-parlay-bet-content
          v-else-if="
            (scope.row.source_type == 'saba' ||
              scope.row.source_type == 'sabawhite_sport') &&
            (scope.row.content_type == 3 || scope.row.content_type == 4)
          "
          :row="scope.row"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></third-party-saba-parlay-bet-content>
        <third-party-saba-parlay-bet-content
          v-else-if="
            scope.row.source_type != 'saba' &&
            scope.row.source_type.includes('sport')
          "
          :row="scope.row"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></third-party-saba-parlay-bet-content>
        <third-party-public-bet-content
          v-else
          :row="scope.row"
        ></third-party-public-bet-content>
      </template>

      <!-- <template slot="header.filter_play" slot-scope="scope">
        <tg-table-filter
          :column="scope.column"
          :filters="filters"
          :showGroup="searchData.third_party"
          @on-change="handleFilterPlay"
        ></tg-table-filter>
      </template> -->
      <template slot="header.filter_play" slot-scope="scope">
        <div
          class="tg-table-filters--wrapper"
          @click="handleBetContentFilterClick()"
        >
          <span>
            {{ scope.column.title }}
          </span>
        </div>
      </template>
      <template slot="header.toggle_percent" slot-scope="scope">
        <div>
          <span>
            {{ scope.column.title }}
          </span>
        </div>
      </template>
      <template slot="status_filter" slot-scope="scope">
        <span v-if="scope.row.status_id == '1'">
          {{ $t("enum.status_filter[1]") }}<br />
        </span>
        <span v-else-if="scope.row.status_id == '2'">
          {{ $t("enum.status_filter[2]") }}<br />
        </span>
        <span v-else-if="scope.row.errorCode == '1'">
          {{ $t("enum.status_filter[3]") }}
        </span>
        <span v-else-if="'insured' in scope.row && scope.row.insured == '1'">
          {{ $t("enum.status_filter[5]") }}
        </span>
      </template>

      <template slot="betId" slot-scope="scope">
        <tg-bet-id :row="scope.row"></tg-bet-id>
      </template>
      <template slot="source_type" slot-scope="scope">
        <span :class="['text-' + scope.row.source_type]">{{
          $t("component.label.source_type." + scope.row.source_type)
        }}</span>
      </template>
      <template slot="cell" slot-scope="scope">
        <span
          :class="{
            'text-red': scope.value < 0,
            'text-green': scope.value > 0,
          }"
          >{{ scope.formated }}</span
        >
      </template>
      <template slot="note" slot-scope="scope">
        <!-- 體驗金注單 -->
        <span v-if="scope.row.errorCode == 1"
          >{{ $t("enum.historyErrorCode[" + scope.row.errorCode + "]") }}<br
        /></span>
        <!-- 智能下單設置編號 -->
        <span v-if="scope.row.smart_no != null">
          {{ $t("component.label.smart_no") + "-" + scope.row.smart_no }}<br />
        </span>
        <!-- 同秒同注單 -->
        <span
          v-if="scope.row.same_type != null && scope.row.same_type < 99"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.same_type[" + scope.row.same_type + "]") }}
        </span>
        <!-- 重新结算 (當該注單重新結算時顯示) -->
        <span v-if="scope.row.isReCount == 1" :class="{ 'text-red': true }">
          {{ $t("component.label.recount") }}
        </span>
        <!-- WM真人 住單【有重對】時顯示【重新結算】 -->
        <span
          v-if="scope.row.content_type == 6 && scope.row.wm_reset == 1"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.recount") }}
        </span>

        <span v-if="scope.row.note" :class="{ 'text-red': true }">
          {{ scope.row.note }}
        </span>
        <br />
        <span
          v-if="scope.row.source_type == 'tg' && scope.row.cancelTime"
          class="text-red"
        >
          ({{ scope.row.cancelTime }})
        </span>
      </template>
      <template slot="reward_cell" slot-scope="scope">
        <span
          :class="{ 'as-link': scope.value > 0 }"
          @click="
            scope.value > 0
              ? handleRewardInfoClick(scope.column, scope.row)
              : null
          "
          >{{ scope.formated }}</span
        >
      </template>
      <template slot="contribution_cell" slot-scope="scope">
        <span
          :class="{ 'as-link': scope.value > 0 }"
          @click="
            scope.value > 0
              ? handleContributionCellClick(scope.column, scope.row)
              : null
          "
          >{{ scope.formated }}</span
        >
      </template>
    </tg-table>

    <tg-history-reward ref="reward" :reward="reward"></tg-history-reward>

    <!-- 獎金info  -->
    <tg-history-reward-info-dialog
      ref="rewardInfo"
      :rewardInfo="rewardInfo"
      @on-click="handleRewardCellClick"
    ></tg-history-reward-info-dialog>

    <!-- <el-dialog
      :title="rewardInfo.title"
      :visible.sync="showRewardInfoDialog"
      width="90%"
      append-to-body
      custom-class="history-reward"
    >
      <tg-history-reward-info-dialog
        :rewardInfo="rewardInfo"
        @on-click="handleRewardCellClick()"
      ></tg-history-reward-info-dialog>
    </el-dialog> -->

    <el-dialog
      :title="contribution.title"
      :visible.sync="showContributionDialog"
      width="90%"
      append-to-body
      custom-class="history-reward"
    >
      <tg-history-contribution
        :contribution="contribution"
      ></tg-history-contribution>
    </el-dialog>

    <!-- 沙巴串關詳情 -->
    <third-party-saba-detail-dialog
      ref="sabaParlayMatchs"
    ></third-party-saba-detail-dialog>
    <!-- 沙巴串關結果 -->
    <third-party-saba-result-dialog
      ref="sabaParlayResult"
    ></third-party-saba-result-dialog>

    <!-- 投注內容篩選彈窗 -->
    <third-party-bet-content-filter-dialog
      ref="betContentFilter"
      :filters="betSelectionfilters"
      @on-change="handleFilterPlay"
      @on-handle="handleFilterSearchData"
      :third_party="thirdPartyData"
    ></third-party-bet-content-filter-dialog>

    <!-- 平台篩選彈窗 -->
    <third-party-check-box-dialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="thirdPartyData"
      @on-click="handleSearchThirdParty"
    ></third-party-check-box-dialog>

    <!-- 平台篩選彈窗 -->
    <market-type-filter-dialog
      ref="marketTypeFilterDialog"
      :marketTypeFilter="marketTypeFilter"
      @on-click="handleSearchMarketType"
    ></market-type-filter-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgSearchTool from "@/components/tool/TgSearchTool";
// import TgUserFullName from "@/components/slot/TgUserFullName";
import TgUserFullNameWithLink from "@/components/slot/TgUserFullNameWithLink";
import TgBetId from "@/components/slot/TgBetId";
import TgBetContent from "@/components/slot/TgBetContent";
import TgButton from "@/components/button/TgButton";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgHistoryReward from "@/components/dialog/TgHistoryReward";
import TgHistoryRewardInfoDialog from "@/components/dialog/TgHistoryRewardInfoDialog";
import TgHistoryContribution from "@/components/dialog/TgHistoryContribution";
import ThirdPartySabaBetContent from "@/components/slot/ThirdPartySabaBetContent";
import ThirdPartySabaParlayBetContent from "@/components/slot/ThirdPartySabaParlayBetContent";
import ThirdPartySabaDetailDialog from "@/components/dialog/ThirdPartySabaDetailDialog";
import ThirdPartySabaResultDialog from "@/components/dialog/ThirdPartySabaResultDialog";
import ThirdPartyPublicBetContent from "@/components/slot/ThirdPartyPublicBetContent";
import ThirdPartyBetContentFilterDialog from "@/components/dialog/ThirdPartyBetContentFilterDialog";
// import TgTableFilter from "@/components/table/TgTableFilter";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from "@/components/tool/ThirdPartyPlatform";
import MarketTypeFilterDialog from "@/components/dialog/MarketTypeFilterDialog";

import { convertToRows, flatColumns } from "@/utils/table";
import { summary } from "@/utils/table";
import str from "@/utils/str";
import xlsx from "@/utils/xlsx";
import { sabaParlayHandler } from "@/mixins/betContent";
import { thirdPartyCheckBoxDialogHandler } from "@/mixins/third_party/dialog";

import apis from "@/apis";

const api = apis.accounts.history;
const STORE_UPDATE = "pages/accounts/history/update";
const STORE_UPDATE_SEARCH = "pages/accounts/history/update_search";

export default {
  components: {
    TgLayout,
    TgDateSearch,
    TgSearchTool,
    // TgUserFullName,
    TgUserFullNameWithLink,
    TgBetId,
    TgBetContent,
    TgButton,
    TgAmountBar,
    TgHistoryReward,
    TgHistoryRewardInfoDialog,
    TgHistoryContribution,
    ThirdPartySabaBetContent,
    ThirdPartySabaParlayBetContent,
    ThirdPartySabaDetailDialog,
    ThirdPartySabaResultDialog,
    ThirdPartyPublicBetContent,
    ThirdPartyBetContentFilterDialog,
    // TgTableFilter,
    ThirdPartyCheckBoxDialog,
    ThirdPartySearchBtn,
    ThirdPartyPlatform,
    MarketTypeFilterDialog,
  },
  mixins: [sabaParlayHandler, thirdPartyCheckBoxDialogHandler],
  data() {
    return {
      columns: [],
      amountData: null,
      amountPageData: {},
      proxy: api.getData,
      dateRange: {},
      // searchData: {
      //   users: [],
      //   filter_play: "",
      //   status_filter: "",
      //   third_party: [],
      // },
      third_party: [],
      groupTag: "",
      upperGroupTag: null,
      clicked: null,
      filterMethods: {
        status_filter: true,
      },
      isFiltered: false,
      sortMethods: {
        num: this.sortData("num"),
        dealmoney: this.sortData("dealmoney"),
        result_quantity: this.sortData("result_quantity"),
        result_obtainOnly: this.sortData("result_obtainOnly"),
      },
      canRefresh: true,
      nextRefresh: 0,
      showAmount: false,
      reward: {},
      rewardInfo: {},
      contribution: {},
      showRewardDialog: false,
      showRewardInfoDialog: false,
      showContributionDialog: false,
      hasData: false,
      isDetail: false,
      showExportMember: true,
      BetSelectionfilters: [],
      selectedUsers: [],
      lastSelectedUsers: [],
      selectionFilter: false,
      togglePercent: 0,
      lastToggleTime: 0,
      showComposed: false,
      prepared: false,
      marketTypeFilter: [1, 2, 3, 0, 6, "-1"],
      showMarketTypeFilter: true,
      showPeople: false,
    };
  },
  created() {
    window.k7 = { decrypt: str.decrypt };

    // let third_party = [...this.thirdParties];
    // this.thirdPartyData = third_party;
    // this.platforms = third_party.map(r => {
    //   return r.platform;
    // });

    // if (this.thirdPartyData) {
    //   this.platforms = this.thirdPartyData;

    //   this.thirdPartyData = this.thirdParties.filter(element => {
    //     return this.thirdPartyData.find(x=>x === element.platform) != undefined;
    //   });
    // }

    if (this.$route.params.invoke == "menu") {
      this.initRequest();
    }

    if (this.$route.params.username && this.$route.query.token) {
      this.$nextTick(() => {
        // this.searchData.targetName = this.$route.params.username;
        let token = JSON.parse(str.decrypt(this.$route.query.token));
        this.filteredUsers = token.users;
        this.filterPlay = token.filter_play;
        this.filterStatus = token.status_filter;
        this.platforms = token.third_party;
        this.groupLine = token.groupLine;
      });
    } else if (this.$route.params.username && !this.clickedUser) {
      // 直接網址輸入名稱或已點擊任何username後按F5
      // 避免缺漏資料，都直接返回第一層
      this.groupLine = "";
      this.$router.push({ name: "accounts.history.index" });
    }

    document.addEventListener("click", (e) => {
      if (
        document.querySelector("thead") &&
        document.querySelector("thead").contains(e.target)
      ) {
        let target = document.querySelector(".tg-table-arrow--wrapper");
        if (target) {
          if (
            e.target.classList.contains("tg-table-arrow--wrapper") ||
            target.contains(e.target)
          ) {
            this.handleColumnArrowClick();
          }
        }
      }
    });

    this.$store.dispatch("pages/accounts/history/fetchColumns").then(() => {
      this.$nextTick(() => {
        this.$refs.table.init(this.request);
        this.prepared = true;
      });
    });
  },
  computed: {
    // 頁面資料儲存庫
    store() {
      return this.$store.state.pages.accounts.history;
    },
    normalColumns() {
      return this.store.normalColumns;
    },
    detailColumns() {
      return this.store.detailColumns;
    },
    amountColumns() {
      return this.isDetail
        ? this.store.detailAmountColumns
        : this.store.normalAmountColumns;
    },
    searchData: {
      get() {
        return this.store.searchData;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, val);
      },
    },
    thirdPartyData: {
      get() {
        return this.store.thirdPartyData;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { thirdPartyData: val });
      },
    },
    betSelectionfilters: {
      get() {
        return this.store.betSelectionfilters;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { betSelectionfilters: val });
      },
    },
    composed: {
      get() {
        return this.store.composed;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { composed: val });
      },
    },
    groupLine: {
      get() {
        return this.store.groupLine;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { groupLine: val });
      },
    },
    // ---- search data ----
    targetName: {
      get() {
        return this.store.searchData.targetName;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, { targetName: val });
      },
    },
    platforms: {
      get() {
        return this.store.searchData.third_party;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, { third_party: val });
      },
    },
    filteredUsers: {
      get() {
        return this.store.searchData.users;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, { users: val });
      },
    },
    clickedUser: {
      get() {
        return this.store.clickedUser;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { clickedUser: val });
      },
    },
    filterPlay: {
      get() {
        return this.store.searchData.filter_play;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, { filter_play: val });
      },
    },
    filterStatus: {
      get() {
        return this.store.searchData.status_filter;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, { status_filter: val });
      },
    },
    market_type: {
      get() {
        return this.store.searchData.market_type;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, { market_type: val });
      },
    },
    request() {
      let request = {
        ...this.searchData,
        ...this.dateRange,
        targetName: this.$route.params.username || this.searchData.targetName,
        groupLine: this.groupLine,
      };

      if (this.marketTypeFilter.indexOf("-1") == -1) {
        request.third_party = ["tg"];
      } else {
        if (this.marketTypeFilter.length == 1) {
          request.third_party = request.third_party.filter((x) => x != "tg");
        }
      }

      return request;
    },
    headerHeight() {
      return !this.showAmount ? 140 : 200;
    },
    dateString() {
      return new Date().toISOString().replace(/[-:.]/g, "");
    },
    parsePageSummary() {
      let data = this.amountPageData ? [this.amountPageData] : [];

      return () => {
        return summary(
          this.columns,
          data,
          this.$t("component.table.summary"),
          this.isDetail ? 4 : 1,
        );
      };
    },
    arrowToggleClass() {
      return [
        // "tg-table-arrow--wrapper close",
        // {close: this.togglePercent === 0, open: this.togglePercent === 1}
      ];
    },
    marketTypeItems() {
      return this.marketTypeFilter.map((item) => {
        return {
          key: item,
          text:
            item == "-1"
              ? this.$t("label.other_third_party")
              : this.$t("enum.marketType[" + item + "]"),
        };
      });
    },
  },
  props: {
    hasUser: Boolean,
  },
  methods: {
    initRequest() {
      this.targetName = "";
      let thirdPartyData = [
        { platform: "tg", category: 0 },
        ...this.thirdParties,
      ];
      let platforms = thirdPartyData.map((x) => x.platform);
      this.thirdPartyData = thirdPartyData;
      this.platforms = platforms;
      this.clickedUser = null;
      this.groupLine = "";
      this.$store.commit("breadcrumb/clear");
    },
    /**
     * 查詢
     */
    handleSearch() {
      this.clickedUser = null;
      this.isFiltered = false;
      this.selectedUsers = [];
      this.lastSelectedUsers = [];
      this.filteredUsers = null;
      this.filterPlay = "";
      this.filterStatus = "";
      this.groupLine = "";
      this.composed = [];
      this.showComposed = false;

      this.$store.commit("breadcrumb/clear");

      //搜尋會員時 清除明細頁的篩選
      if (this.isDetail) {
        let ElTable = this.$refs.table.$refs.ElTable;
        let ElColumns = ElTable.store.states.originColumns;

        let ElColumnIndex = ElColumns.findIndex(
          (x) => x.columnKey == "status_filter",
        );

        // 透過重設columns的參數來初始化篩選值，以讓倒三角形恢復白色
        ElColumns[ElColumnIndex].filteredValue = [];

        // 利用觸發篩選的方式來查詢
        // 1. 刷新篩選項目
        // 2. 統一由handleFilterChange處理查詢
        ElTable.store.commit("filterChange", {
          column: ElColumns[ElColumnIndex],
          values: "",
        });

        //清空篩選
        this.filterPlay = "";
        this.filterStatus = "";
        return;
      }

      this.searchData.showPeople = this.showPeople;

      if (this.$route.params.username) {
        this.$router.push({ name: "accounts.history" });
      } else {
        this.$refs.table.search(this.request);
      }
    },
    /**
     * 處理response
     */
    handleLoaded(response) {
      this.hasData = response.data.length > 0;
      this.amountPageData = response.amount_page;
      this.amountData = {
        ...response.amount_total,
        event_bouns: response.amount_total.event_bouns
          ? response.amount_total.event_bouns
          : "0",
      };
      this.composed = JSON.parse(JSON.stringify(response.composed));
      this.groupLine = response.groupLine;
      this.showComposed = response.composed.length > 1;

      // 篩選項目無資料，不做更新表的動作
      if (this.selectionFilter && response.data.length == 0) {
        return;
      }

      let columns = JSON.parse(JSON.stringify(this.normalColumns));
      this.isDetail = false;
      this.showExportMember = response.groupTag != "l10";

      if (columns.length > 0) {
        if (response.is_detail) {
          this.isDetail = true;
          this.showExportMember = false;
          columns = JSON.parse(JSON.stringify(this.detailColumns));
          // columns[3].filters = this.filters;
          // columns[3]["filter-multiple"] = false;
          let status_filters = response.selections["status_filters"];
          if (status_filters.length !== 0) {
            columns[6].filters = response.selections["status_filters"];
            columns[6]["filter-multiple"] = false;
          } else {
            columns[6].filters = null;
          }

          this.filteredUsers = [];
        } else {
          this.searchData.filter = null;
          this.filterStatus = null;
          if (response.groupTag == "l10") {
            let result_quantity = columns.find(
              (x) => x.name == "result_quantity",
            );

            if (result_quantity) {
              delete result_quantity.width;
            }
            // 代理不用顯示佔成反水+微商相關欄位，只取前面欄位~TG反水之間的欄位 + 實貨量欄位
            let splitIndex = columns.findIndex((x) => x.name == "breakwater");
            columns = [...columns.slice(0, splitIndex)];
            if (result_quantity) {
              columns.push(result_quantity);
            }

            columns.map((cc) => delete cc.width);

            columns = columns.filter((c) => {
              return "third_party" in c ? false : true;
            });
          } else {
            columns = this.getFilteredAgentColumns(this.togglePercent);
          }

          columns[1].langKey = response.groupTag
            ? response.groupTag + "_account"
            : "l10_account";
        }
      }

      columns = columns?.map((ccc) => {
        if ("tip" in ccc) {
          if (ccc.tip === "marketTypeFilter") {
            if (this.marketTypeFilter.length === 6) {
              ccc.tip = "tip.all_market_types";
            } else {
              ccc.tip = "";
            }
          }
        }

        return ccc;
      });

      this.groupTag = response.groupTag;

      this.upperGroupTag = response.upperGroupTag;

      this.showAmount =
        response.data.length > 0 && !("length" in response.amount_page);

      this.columns = JSON.parse(JSON.stringify(columns));

      this.$nextTick(() => {
        if (this.clickedUser) {
          this.addBreadcrumb(response.is_detail);
        } else {
          this.$store.commit("breadcrumb/clear");
        }
      });
    },
    /**
     * 新增麵包屑
     */
    addBreadcrumb(isDetail) {
      let title;
      if (this.upperGroupTag) {
        title = str.format(
          "{0} ({1})",
          this.$t("column." + this.upperGroupTag),
          this.clickedUser,
        );
      } else {
        title = str.format("{0}", this.clickedUser);
      }

      if (isDetail) {
        title = this.clickedUser;
      }

      this.$store.commit("breadcrumb/add", {
        id: "accounts.history.user_" + this.clickedUser,
        name: "accounts.history.user",
        query: {
          ...this.$route.query,
        },
        params: {
          username: this.clickedUser,
        },
        meta: {
          title: title,
        },
      });
    },
    handleUserClick(row, column) {
      this.clickedUser = row[column.name];
      this.clicked = row;
      this.selectedUsers = [];
      this.lastSelectedUsers = [];
      this.filteredUsers = null;

      let route = "accounts.history.user";

      if (row["group"] == 10) {
        this.columns = this.detailColumns;
      } else {
        this.columns = this.normalColumns;
      }

      let token = this.generalQueryToken(row); //str.encrypt(JSON.stringify(this.request))

      this.$router.push({
        name: route,
        params: {
          username: row[column.name],
          token: token,
        },
        query: {
          token: token,
        },
      });
    },
    setUserToken(row, column) {
      let token = str.encrypt(JSON.stringify(this.request));
      let href =
        location.origin +
        location.pathname +
        this.$router.resolve({
          name: "accounts.history.user",
          params: { username: row[column.name] },
          query: { token: token },
        }).href;
      return href;
    },
    /**
     * 切換頁面
     * 如果網址列有帶username參數，則帶入查詢參數
     */
    togglePage(hasUser, route) {
      this.filteredUsers = [];
      this.isFiltered = false;
      if (hasUser) {
        this.clickedUser = route.params.username;
        let request = { ...this.request };
        let token = JSON.parse(str.decrypt(route.query.token));
        request.users = token.users;
        request.filter_play = token.filter_play;
        request.status_filter = token.status_filter;
        request.third_party = token.third_party;
        request.groupLine = token.groupLine;

        this.$refs.table.search({
          ...request,
          targetName: route.params.username,
        });
      } else {
        this.$store.commit("breadcrumb/clear");
        this.clickedUser = null;
        this.groupLine = "";
        this.$nextTick(() => {
          this.$refs.table.init(this.request);
        });
      }
    },
    handleBetContentFilterClick() {
      this.$refs.betContentFilter.showDialog();
    },
    handleRewardCellClick(rewardInfo) {
      this.reward = { ...rewardInfo, groupLine: this.groupLine };
      this.$refs.reward.showDialog();
    },
    handleRewardInfoClick(column, row) {
      this.rewardInfo = {
        status: column.reward_status,
        type: column.reward_type,
        targetName: row.username,
        ...this.dateRange,
        third_party: this.platforms,
        title: str.format(
          "{0}({1}) - {2}",
          row.username,
          row.usernickname,
          this.$t("column." + column.langKey),
        ),
        groupLine: this.groupLine,
      };
      this.$refs.rewardInfo.showDialog();
    },
    handleContributionCellClick(column, row) {
      this.contribution = {
        status: column.contribution_status,
        targetName: row.username,
        ...this.dateRange,
        title: str.format(
          "{0}({1}) - {2}",
          row.username,
          row.usernickname,
          this.$t("column." + column.langKey),
        ),
      };
      this.showContributionDialog = true;
    },
    /**
     * 投注內容欄位篩選器
     */
    filterMarket() {
      return true;
    },
    sortData(column) {
      return (a, b) => {
        return a[column] - b[column];
      };
    },
    /**
     * 篩選特定目標以做刷新
     */
    handleUserFilter(reset) {
      let ElTable = this.$refs.table.$refs.ElTable;
      let selected;

      if (reset) {
        selected = this.lastSelectedUsers;
        this.isFiltered = false;
      } else {
        selected = ElTable.store.states.selection.map((x) => x.username);

        if (selected.length == 0) {
          return;
        }

        this.lastSelectedUsers = [...this.selectedUsers];
        this.isFiltered = true;
      }

      this.selectedUsers = selected;
      this.filteredUsers = selected;

      this.$nextTick(() => {
        let request = { ...this.request };
        request.users = selected;
        if (this.$route.params.username) {
          request.targetName = this.$route.params.username;
        }
        this.$refs.table.search(request);
      });
    },
    /**
     * 刷新已篩選的資料
     */
    handleRefreshFiltered() {
      if (!this.canRefresh) {
        return;
      }
      let request = { ...this.request };
      request.users = this.selectedUsers;
      if (this.$route.params.username) {
        request.targetName = this.$route.params.username;
      }
      this.$refs.table.search(request);

      this.intervalRefreshTime();
    },
    /**
     * 刷新限制控制
     */
    intervalRefreshTime() {
      this.nextRefresh = 60;
      this.canRefresh = false;

      setInterval(() => {
        this.nextRefresh--;

        if (this.nextRefresh <= 0) {
          this.canRefresh = true;
        }
      }, 1000);
    },
    handleExport() {
      let normalColumns = JSON.parse(JSON.stringify(this.columns));

      if (!this.isDetail) {
        normalColumns = this.getFilteredAgentColumns(1);
        normalColumns[1].langKey = this.groupTag + "_account";

        normalColumns[1].xlsx = {
          ...normalColumns[1].xlsx,
          component: TgUserFullNameWithLink,
        };
      } else {
        normalColumns[3].width = 450;
      }
      let headerRow = convertToRows(normalColumns);
      let columns = flatColumns(normalColumns);

      // let exportFileName = "历史报表";
      let exportFileName = this.$t("component.export.historical_statement");
      if (this.isDetail) {
        let request = { ...this.request, isExport: true };
        if (this.$route.params.username) {
          request.targetName = this.$route.params.username;
        }
        this.proxy(request).then((response) => {
          let data = response.data;
          let ws = xlsx.makeSheet(
            headerRow,
            columns,
            data,
            response.amount_page,
          );
          xlsx.exportExcel(ws, exportFileName + "-" + this.dateString);
        });
      } else {
        //使用compiledData 取得已篩選的資料
        let table = this.$refs.table.$refs.ElTable;
        let data = table.store.states.filteredData;
        let ws = xlsx.makeSheet(headerRow, columns, data, this.amountData);
        xlsx.exportExcel(ws, exportFileName + "-" + this.dateString);
      }
    },
    handleExportMember() {
      let table = this.$refs.table.$refs.ElTable;
      // origin data
      let indexData = table.store.states._data;
      // filtered data
      let compiledData = table.store.states.filteredData;

      let excluded = [];
      if (indexData.length != compiledData) {
        indexData.forEach((row) => {
          if (compiledData.some((r) => row.username === r.username)) {
            return;
          }
          excluded.push(row["username"]);
        });
      }

      // excluded = JSON.stringify(excluded);
      let request = {
        ...this.request,
        excluded,
      };
      if (this.$route.params.username) {
        request.targetName = this.$route.params.username;
      }
      api.getMemberExport(request).then((response) => {
        if (response.retcode == 0) {
          let { data, total, columns } = response;
          columns = columns
            .slice(0, -5)
            .filter(
              (x) => (x.name == "breakwater" || "is_percent" in x) == false,
            );
          let headerRow = convertToRows(columns);
          let allColumns = flatColumns(columns);
          let ws = xlsx.makeSheet(headerRow, allColumns, data, total);
          // xlsx.exportExcel(ws, "会员历史报表-" + this.dateString);
          xlsx.exportExcel(
            ws,
            this.$t("component.export.member_historical") +
              "-" +
              this.dateString,
          );
        }
      });
    },
    handleExportAllLevels() {
      // 1. 準備欄位配置
      let normalColumns = JSON.parse(JSON.stringify(this.columns));
      normalColumns = this.getFilteredAgentColumns(1);
      normalColumns[1].langKey = this.groupTag + "_account";
      normalColumns[1].xlsx = {
        ...normalColumns[1].xlsx,
        component: TgUserFullNameWithLink,
      };

      // 保留所有欄位，包括第三方平台占成欄位
      const filteredColumns = normalColumns;

      // 轉換為二維表頭結構
      let headerRow = convertToRows(filteredColumns);
      let columns = flatColumns(filteredColumns);
      const excelColumns = columns.filter((col) => col.type !== "selection");

      // 3. 定義值格式化函數
      const formatValue = (value, isPercent) => {
        if (isPercent) {
          return `${(value * 100).toFixed(0)}.00%`;
        }
        if (typeof value === "number") {
          return value;
        }
        return value !== undefined && value !== null ? value : "0.00";
      };

      // 4. 準備 API 請求參數
      let request = { ...this.request };
      if (this.$route.params.username) {
        request.targetName = this.$route.params.username;
      }

      // 5. 執行 API 請求
      let exportFileName = this.$t(
        "component.export.allGroup_historical_statement",
      );

      api.getAllLevelsExport(request).then((response) => {
        if (response.retcode !== 0) return;

        let allData = []; // 收集所有層級的資料
        const firstColName = excelColumns[0].name;
        const levelKeys = Object.keys(response.data).sort((a, b) => b - a);
        const firstGroupKey = levelKeys[0];

        // 6. 組裝資料
        levelKeys.forEach((key, levelIndex) => {
          if (levelIndex > 0) {
            allData.push({
              _insertHeader: true,
              groupKey: key,
            }); // 只插入標記，不插入實際資料
          }

          // 添加該層級的用戶資料
          response.data[key].forEach((subItem) => {
            const formattedRow = {};
            excelColumns.forEach((col) => {
              if (col.type === "selection") return;
              if (col.name === "username") {
                formattedRow.username = subItem.usernickname
                  ? `${subItem.username}(${subItem.usernickname})`
                  : subItem.username;
              } else {
                formattedRow[col.name] = formatValue(
                  subItem[col.name],
                  col.is_percent,
                );
              }
            });

            allData.push(formattedRow);
          });

          // 添加該層級的小計
          if (response.amountData[key]) {
            const summaryRow = {
              [firstColName]: this.$t("component.table.summary"),
              _isSummary: true,
            };

            excelColumns.forEach((col) => {
              if (col.type === "selection" || col.name === firstColName) return;
              if (col.is_percent) {
                summaryRow[col.name] = "";
              } else {
                summaryRow[col.name] = formatValue(
                  response.amountData[key][col.name],
                  col.is_percent,
                );
              }
            });
            allData.push(summaryRow);
          }
        });

        // 7. 創建 worksheet
        let ws = xlsx.makeSheetAll(
          headerRow,
          excelColumns,
          allData,
          firstGroupKey,
          levelKeys,
          this.marketTypeFilter.length,
        );

        // 8. 匯出 Excel
        xlsx.exportExcel(ws, exportFileName + "-" + this.dateString);
      });
    },
    handleTableScroll(e) {
      let target = e.target;
      if (this.$refs.amount) {
        this.$refs.amount.syncScrollX(
          target.scrollWidth - target.offsetWidth,
          target.scrollLeft,
        );
      }
    },
    pageChanged() {
      let ElTable = this.$refs.table.$refs.ElTable;
      ElTable.store.states.filteredData = ElTable.store.states._data;
    },
    // 篩選後刷新總計資訊
    handleFilterChange(response) {
      if ("status_filter" in response) {
        this.filterStatus =
          response.status_filter.length > 0 ? response.status_filter[0] : null;
      }

      this.selectionFilter =
        this.filterPlay.length > 0 || this.filterStatus > 0;

      this.$nextTick(() => {
        let request = { ...this.request };
        if (this.clickedUser) {
          request.targetName = this.clickedUser;
        }
        this.$refs.table.search(request);
      });
    },
    //取得要搜尋的平台
    handleSearchThirdParty(value) {
      this.thirdPartyData = value;
      this.platforms = this.thirdPartyData.map((r) => {
        return r.platform;
      });

      if (this.prepared) {
        this.$nextTick(() => {
          let request = { ...this.request };
          if (this.clickedUser) {
            request.targetName = this.clickedUser;
          }
          this.$refs.table.search(request);
        });
      }
    },
    handleFilterPlay(value) {
      this.filterPlay = value;
      this.selectionFilter =
        this.filterPlay.length > 0 || this.filterStatus > 0;

      this.$nextTick(() => {
        let request = { ...this.request };
        if (this.clickedUser) {
          request.targetName = this.clickedUser;
        }
        this.$refs.table.search(request);
      });
    },
    handleFilterSearchData(value) {
      this.filterPlay = "";
      this.$nextTick(() => {
        let request = { ...this.request };
        request.third_party = value;
        if (this.clickedUser) {
          request.targetName = this.clickedUser;
        }

        this.$refs.table.search(request);
      });
    },
    getFilteredAgentColumns(toggle_percent) {
      let columns = JSON.parse(JSON.stringify(this.normalColumns));
      // 先過濾掉第三方篩選的欄位
      columns = columns.filter((column) => {
        let ck = true;

        if ("third_party" in column && column.third_party.length > 0) {
          ck = this.platforms.findIndex((x) => x == column.third_party) > -1;
        }

        if (column.name == "number_of_bet_people") {
          ck = this.searchData.showPeople;
        }
        return ck;
      });

      columns = columns.map((ccc) => {
        if ("tip" in ccc) {
          if (ccc.tip === "marketTypeFilter") {
            if (this.marketTypeFilter.length === 6) {
              ccc.tip = "tip.all_market_types";
            } else {
              ccc.tip = "";
            }
          }
        }
        return ccc;
      });

      let firstPercentCol = columns.findIndex((x) => "is_percent" in x);
      let percentColCount = columns.reduce((a, c) => {
        if ("is_percent" in c) {
          a++;
        }
        return a;
      }, 0);

      if (firstPercentCol < 0 || percentColCount <= 1) {
        return columns;
      }
      columns[firstPercentCol].headerSlot = "toggle_percent";
      columns[firstPercentCol].width = "150";
      columns[firstPercentCol].class =
        "tg-table-arrow--wrapper " + (toggle_percent === 0 ? "close" : "open");

      columns = columns.filter((column, index) => {
        let ck = true;

        // 為0時，只顯示第一個佔成欄位
        if (toggle_percent == 0 && "is_percent" in column) {
          ck = index == firstPercentCol;
        }
        return ck;
      });
      return columns;
    },
    handleColumnArrowClick() {
      let toggle_percent = this.togglePercent === 0 ? 1 : 0;
      if (this.togglePercent == toggle_percent) {
        return;
      }
      this.togglePercent = toggle_percent;

      this.columns = this.getFilteredAgentColumns(toggle_percent);
    },
    generalQueryToken(row) {
      let targetId = "userid" in row ? row.userid : row.user_id;
      let groupLine =
        row.group == 10
          ? this.groupLine
          : this.groupLine + "-" + row.group + ":" + targetId;

      let token = str.encrypt(
        JSON.stringify({
          ...this.request,
          groupLine: groupLine,
        }),
      );
      return token;
    },
    toggleGroupLine(row) {
      let request = { ...this.request };
      request.groupLine = row.value;

      this.$refs.table.search(request);
    },
    handleSearchMarketType(values) {
      this.marketTypeFilter = [...values];
      let request = { ...this.request };
      // 不查三方
      if (values.indexOf("-1") == -1) {
        request.third_party = ["tg"];
      } else {
        if (values.length == 1) {
          request.third_party = request.third_party.filter((x) => x != "tg");
        }
      }
      request.market_type = values.filter((x) => x != -1);

      this.$refs.table.search(request);
    },
    showMarketTypeFilterDialog() {
      this.$refs.marketTypeFilterDialog.showDialog();
    },
    handleMarketTypeItemsChange(items) {
      let marketTypes = (this.marketTypeFilter = items.map((x) => x.key));
      this.handleSearchMarketType(marketTypes);
    },
  },
  watch: {
    hasUser(val) {
      this.togglePage(val, this.$route);
    },
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    marketTypeFilter(val) {
      this.market_type = val.filter((x) => x != -1);
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.togglePage(to.params.username, to);

    next();
  },
};
</script>
